import api from './api';

export const availabilityService = {
  // Get all availability for a user
  getUserAvailabilityByUserId: async (userId) => {
    try {
      const response = await api.get(`/user-availability/user/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching user availability:', error);
      throw error;
    }
  },

  // Get availabilities for a user at a specific location
  getUserAvailabilityByUserIdAndLocationId: async (userId, locationId) => {
    try {
      const response = await api.get(`/user-availability/user/${userId}/location/${locationId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching user availability by location:', error);
      throw error;
    }
  },

  // Get available slots for a user
  getAvailableSlotsByUserId: async (userId) => {
    try {
      const response = await api.get(`/user-availability/user/${userId}/available`);
      return response.data;
    } catch (error) {
      console.error('Error fetching available slots:', error);
      throw error;
    }
  },

  // Get available slots for multiple users
  getAvailableSlotsByUserIds: async (userIds) => {
    try {
      const response = await api.post('/user-availability/users/available', userIds);
      return response.data;
    } catch (error) {
      console.error('Error fetching available slots for users:', error);
      throw error;
    }
  },

  // Update availability for a user (bulk update)
  updateUserAvailability: async (userId, availabilityData) => {
    try {
      console.log('Sending availability update request:', { userId, availabilityData });
      const response = await api.put(`/user-availability/user/${userId}`, availabilityData);
      return response.data;
    } catch (error) {
      console.error('Error updating user availability:', error);
      if (error.response) {
        console.error('Error response data:', error.response.data);
        console.error('Error response status:', error.response.status);
        console.error('Error response headers:', error.response.headers);
      }
      throw error;
    }
  },

  // Update a single availability slot
  updateUserAvailabilitySlot: async (userId, locationId, dayOfWeek, startTime, endTime, isAvailable) => {
    try {
      const response = await api.put(`/user-availability/user/${userId}/slot`, null, {
        params: {
          locationId,
          dayOfWeek,
          startTime,
          endTime,
          isAvailable
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error updating availability slot:', error);
      throw error;
    }
  },

  // Delete all availability for a user
  deleteUserAvailabilityByUserId: async (userId) => {
    try {
      const response = await api.delete(`/user-availability/user/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting user availability:', error);
      throw error;
    }
  },

  // Delete availabilities for a user at a specific location
  deleteUserAvailabilityByUserIdAndLocationId: async (userId, locationId) => {
    try {
      const response = await api.delete(`/user-availability/user/${userId}/location/${locationId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting user availability by location:', error);
      throw error;
    }
  },

  // Save team supervisor availabilities for the current user
  saveTeamSupervisorAvailabilities: async (userId, availabilities) => {
    try {
      const response = await api.post(`/user-availability/team-supervisor/${userId}`, availabilities);
      return response.data;
    } catch (error) {
      console.error('Error saving team supervisor availabilities:', error);
      throw error;
    }
  }
}; 